import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../../context/Context";
import "./Humidity.css";
import ScenarioHumiditySetTempModal from "../../modals/ScenarioHumiditySetTempModal";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Humidity = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  commands,
  setCommands,
}) => {
  const {
    addScenarioCommandDetail,
    scenarioCommandDetail,
    scenarioCommands,
    setScenarioCommands,
    handleSetHumidityModal,
    setIsLoading,
    equipmentButtons,
    devices,
  } = useContext(Context);

  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState(null);
  const [changeButton, setChangeButton] = useState(null);
  const [modalType, setModalType] = useState(null);

  // تعریف آرایه برای نمایش ترتیب جدید: خاموش، روشن، گرمایش، سرمایش
  const displayOrder = [2, 0, 3, 1]; // ترتیب نمایش
  const modeNames = ["خاموش", "روشن", "رطوبت‌ساز", "خشک‌‌کننده"];

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleChangeMode = (button) => {
    setSelectedButton({
      id: button.id,
      mode:
        selectedButton && selectedButton.id == button.id
          ? (selectedButton.mode + 1) % 4
          : 2,
      temp: selectedButton && selectedButton.temp ? selectedButton.temp : 25,
      diff: selectedButton && selectedButton.diff ? selectedButton.diff : 2,
    });
  };

  const handleSetTemp = (value) => {
    if (changeButton) {
      setSelectedButton((prev) => ({
        ...prev,
        id: changeButton.id,
        mode:
          selectedButton && selectedButton.id == changeButton.id
            ? selectedButton.mode
            : 0,
        temp: value,
      }));
    }
  };

  const handleSetDiff = (value) => {
    if (changeButton) {
      setSelectedButton((prev) => ({
        ...prev,
        id: changeButton.id,
        mode:
          selectedButton && selectedButton.id == changeButton.id
            ? selectedButton.mode
            : 3,
        diff: value,
      }));
    }
  };

  const handleSubmit = () => {
    const button = buttons.find((btn) => btn.id == selectedButton.id);
    let data1 = 8;
    let data2 = selectedButton.mode;
    let data3 = selectedButton.temp;
    let data4 = selectedButton.diff;

    if (scenarioCommandDetail.id) {
      // setIsLoading(true);
      setCommands((prevCommands) =>
        prevCommands.map((command) =>
          command.id == scenarioCommandDetail.id
            ? {
                ...command,
                device_id: button.device_id,
                time: scenarioCommandDetail.time,
                data1: data1,
                data2: data2,
                data3: data3,
                data4: data4,
                data5: null,
                data6: null,
                data7: null,
                data8: null,
                data9: null,
                data10: null,
                data11: null,
                command_name: "HUM",
                icon: button.icon,
              }
            : command
        )
      );
      setSelectedButton(null);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // UpdateScenarioCommand({
      //   scenario_command_id: scenarioCommandDetail.id,
      //   device_id: button.device_id,
      //   time: scenarioCommandDetail.time,
      //   data1: data1,
      //   data2: data2,
      //   data3: data3,
      //   data4: data4,
      //   command_name: button.name,
      //   icon: button.icon,
      // }).then(({ data: sData }) => {
      //   SuccessToast("دستور با موفقیت جایگزین شد");
      //   const newScenarioCommands = scenarioCommands.map((scn) => {
      //     if (scn.id === scenarioCommandDetail.id) {
      //       return {
      //         ...scn,
      //         device_id: button.device_id,
      //         time: scenarioCommandDetail.time,
      //         data1: data1,
      //         data2: data2,
      //         data3: data3,
      //         data4: data4,
      //         command_name: button.name,
      //         icon: button.icon,
      //       };
      //     }
      //     return scn;
      //   });
      //   setScenarioCommands(newScenarioCommands);
      //   setSelectedButton(null);
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    } else {
      setCommands((prev) => [
        ...prev,
        {
          id: new Date().getTime(),
          scenario_id: addScenarioCommandDetail.scenario_id,
          data1: data1,
          data2: data2,
          data3: data3,
          data4: data4,
          data5: null,
          data6: null,
          data7: null,
          data8: null,
          data9: null,
          data10: null,
          data11: null,
          command_name: "HUM",
          icon: button.icon,
          device_id: button.device_id,
          time: 500,
        },
      ]);
      setSelectedButton(null);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // CreateScenarioCommand({
      //   scenario_id: addScenarioCommandDetail.scenario_id,
      //   data1: data1,
      //   data2: data2,
      //   data3: data3,
      //   data4: data4,
      //   command_name: button.name,
      //   icon: button.icon,
      //   device_id: button.device_id,
      //   time: 500,
      // }).then(({ data }) => {
      //   SuccessToast("دستور با موفقیت اضافه گردید");
      //   setScenarioCommands([...scenarioCommands, data.scenario_command]);
      //   setSelectedButton(null);
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    }
    setSelectedButton(null);
  };

  const modeImages = [
    "/assets/img/app-icons/-p.png", // Mode 2 رطوبت ساز
    "/assets/img/app-icons/si.png", // Mode 3 خشک کننده
    "/assets/img/app-icons/turn-off-r.png", // Mode 0 خاموش
    "/assets/img/app-icons/turn-on.png", // Mode 1 روشن
  ];

  const getModeImage = (button) => {
    if (selectedButton && selectedButton.id === button.id) {
      return modeImages[selectedButton.mode];
    }
    return modeImages[displayOrder[0]]; // Using displayMode from the displayOrder
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      return (
        <div
          key={button.id}
          className="humidity mb-3"
          style={{
            boxShadow:
              selectedButton && selectedButton.id === button.id
                ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
                : "0 0.25rem 1rem rgba(147, 158, 170, 0.45)",
          }}
        >
          <div className="row mx-0">
            <div className="col my-auto px-0">
              <div className="d-flex justify-content-between mb-2">
                <div>
                  <span>تنظیم</span>
                </div>
                <div
                  className="text-center"
                  onClick={() => {
                    setChangeButton(button);
                    setModalType(1);
                    handleSetHumidityModal(true);
                  }}
                >
                  <span className="ms-1">
                    {selectedButton &&
                    selectedButton.id == button.id &&
                    selectedButton.temp != undefined
                      ? selectedButton.temp + "°C"
                      : "-"}
                  </span>
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <div>
                  <span>تغییرات</span>
                </div>
                <div
                  className="text-center"
                  onClick={() => {
                    setChangeButton(button);
                    setModalType(2);
                    handleSetHumidityModal(true);
                  }}
                >
                  <span className="ms-1">
                    {selectedButton &&
                    selectedButton.id == button.id &&
                    selectedButton.diff != undefined
                      ? selectedButton.diff + "°C"
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
            <div
              className="col my-auto px-0 text-center"
              onClick={() => handleChangeMode(button)}
            >
              <img
                src={getModeImage(button)}
                style={{ width: "30px" }}
                alt={modeNames[0]}
              />
            </div>
            <div className="col my-auto px-0">
              <div className="text-center">
                <span>-</span>
              </div>
              <div className="hum-status bg-success"></div>
            </div>
            <div className="col my-auto px-0">
              <div className="text-center">
                <p className="text-center p-0 m-0 d-block">{button.name}</p>
              </div>
              <div className="text-center mt-2">
                <span style={{ fontSize: "11px" }}>
                  C{button.digit + 1}-S/
                  {devices.find((d) => d.id == button.device_id)?.serial}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
        <div
          className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
          style={{ zIndex: 1, top: "0" }}
        >
          <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
          <button
            type="button"
            className="btn btn-icon btn-success-app"
            onClick={handleSubmit}
          >
            <span className="tf-icons bx bx-check"></span>
          </button>
        </div>
        <div className="card-body scrollbar">
          {/* <SimpleBar style={{ maxHeight: "100%", padding: "1rem" }}> */}
            {renderButtons()}
          {/* </SimpleBar> */}
        </div>
      </div>
      <ScenarioHumiditySetTempModal
        selectValue={0}
        setTemp={handleSetTemp}
        setDiff={handleSetDiff}
        type={modalType}
      />
    </>
  );
};

export default React.memo(Humidity);
